import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { DoBootstrap, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  cookieInterceptorProvider,
  ElementRoutes,
  ElementsModule,
  httpCacheInterceptorProvider,
  PipesModule,
} from "@vattenfall/core";
import { SelfServiceModule } from "@vattenfall/self-service";

import { environment } from "../environments/environment";

import { AutocompleteSearchServiceMockup } from "./autocomplete-search/autocomplete-search.service.mockup";
import { CampaignProductCardFinlandServiceMockup } from "./campaign-product-card-finland/campaign-product-card-finland.service.mockup";
import { DirectSearchServiceMockup } from "./direct-search/direct-search-mockup.service";
import { FlowsMoveAlongPrivateFinlandServiceMockup } from "./flows-move-along-private-finland/flows-move-along-private-finland.mockup";

const MOCKUP = environment.production
  ? []
  : [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AutocompleteSearchServiceMockup,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: CampaignProductCardFinlandServiceMockup,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: FlowsMoveAlongPrivateFinlandServiceMockup,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: DirectSearchServiceMockup,
        multi: true,
      },
    ];

const ELEMENTS: ElementRoutes = [
  {
    tagName: "autocomplete-search",
    loadChildren: () => import("./autocomplete-search/autocomplete-search.module").then((mod) => mod.AutocompleteSearchModule),
  },
  {
    tagName: "chat-app",
    loadChildren: () => import("./chat-app/chat-app.module").then((mod) => mod.ChatAppModule),
  },
  {
    tagName: "elements-example",
    loadChildren: () => import("./example/example.module").then((mod) => mod.ExampleModule),
  },
  {
    tagName: "my-consumption",
    loadChildren: () => import("./my-consumption/my-consumption.module").then((mod) => mod.MyConsumptionModule),
  },
  {
    tagName: "my-premises-select-two",
    loadChildren: () =>
      import("./my-premises-select-two/my-premises-select-two.module").then((mod) => mod.MyPremisesSelectTwoModule),
  },
  {
    tagName: "campaign-product-card-finland",
    loadChildren: () =>
      import("./campaign-product-card-finland/campaign-product-card-finland.module").then(
        (mod) => mod.CampaignProductCardFinlandModule
      ),
  },
  {
    tagName: "my-profile",
    loadChildren: () => import("./my-profile/my-profile.module").then((mod) => mod.MyProfileModule),
  },
  {
    tagName: "outage-subscription-dialog-heat",
    loadChildren: () =>
      import("./outage-subscription-dialog-heat/outage-subscription-dialog-heat.module").then(
        (mod) => mod.OutageSubscriptionDialogModule
      ),
  },
  {
    tagName: "hourly-spot-price-chart",
    loadChildren: () =>
      import("./hourly-spot-price-chart/hourly-spot-price-chart.module").then((mod) => mod.HourlySpotPriceChartModule),
  },
  {
    tagName: "direct-search",
    loadChildren: () => import("./direct-search/direct-search.module").then((module) => module.DirectSearchModule),
  },
  {
    tagName: "carousel-element",
    loadChildren: () => import("./carousel-element/carousel-element.module").then((mod) => mod.CarouselElementModule),
  },
  {
    tagName: "flows-move-along-private-finland",
    loadChildren: () =>
      import("./flows-move-along-private-finland/flows-move-along-private-finland.module").then(
        (mod) => mod.FlowsMoveAlongPrivateFinlandModule
      ),
  },
  {
    tagName: "customer-service-funnel",
    loadChildren: () =>
      import("./customer-service-funnel/customer-service-funnel.module").then((mod) => mod.CustomerServiceFunnelModule),
  },
];

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    PipesModule,
    SelfServiceModule.forRoot({ mockup: !environment.production }),
    ElementsModule.forRoot(ELEMENTS),
  ],
  providers: [cookieInterceptorProvider, httpCacheInterceptorProvider, ...MOCKUP],
  declarations: [],
  exports: [],
})
export class AppModule implements DoBootstrap {
  ngDoBootstrap() {}
}
